import React from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '../../settings/withDirection';

const AntModal = props => <Modal {...props} />;

const Modals = styled(AntModal)`


  .ant-modal-header{
    background-color:#313539;
    box-shadow: 1px 1px 5px 0px #222;
    border: none;
    height:40px;
  }

  .ant-modal-title{
    color:#fff;
    position: relative;
    bottom: 7px;
  }

  
  .ant-modal-content .ant-modal-close .anticon{
    color: #fff;
    position: relative;
    bottom: 7px;
  }


  .ant-modal-footer {
    display:flex;
  }
  .ant-modal-footer .ant-btn{
    border: 1px solid transparent;
    box-shadow: 0px 4px 5px 0px #00000040;
  }
  
  .ant-modal-footer .ant-btn.ant-btn-primary{
    border: 1px solid transparent;
    box-shadow: 0px 4px 5px 0px #00000040;
    position: absolute;
    right: 10px;
  }



  
`;

export default WithDirection(Modals);
